<template>
  <div>
    <div class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="is-pulled-right" v-if="$route.name.indexOf('orders') !== -1">
            <button class="button is-primary" @click="printAll()">
              Print All
            </button>
          </div>
          <h1 class="title" v-if="$route.name.indexOf('orders') !== -1">
            {{ company.name }} Orders
            <button class="button is-primary"
                    :disabled="apiBusy"
                    @click="refreshAll()">
              Check for New Orders
            </button>
            <small style="font-size: 1.25rem">(last checked {{ last_check }})</small>
          </h1>
          <h1 class="title" v-if="$route.name === 'order'">
            <router-link :to="{ name: 'orders' }">Orders</router-link>
            &rarr;
            #{{ currentOrder.id }}
            <button class="button is-primary is-pulled-right" @click="printOrder()">Print Order</button>
          </h1>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="tabs" v-if="$route.name.indexOf('orders') !== -1">
        <ul>
          <router-link tag="li" :to="{ name: 'orders' }" exact>
            <a><span class="tag is-rounded is-danger">{{ newOrders.length }}</span> &nbsp; New Orders</a>
          </router-link>
          <router-link tag="li" :to="{ name: 'printed-orders' }">
            <a><span class="tag is-rounded is-primary">{{ printedOrders.length }}</span> &nbsp;
              Printed Orders</a>
          </router-link>
          <router-link tag="li" :to="{ name: 'archived-orders' }">
            <a><span class="tag is-rounded is-success">{{ archivedOrders.length }}</span> &nbsp;
              Archived Orders</a>
          </router-link>
          <router-link tag="li" :to="{ name: 'past-orders' }">
            <a><span class="tag is-rounded is-success">{{ pastOrders.length }}</span> &nbsp;
              Last Year Orders</a>
          </router-link>
          <router-link tag="li" :to="{ name: 'voided-orders' }">
            <a><span class="tag is-rounded is-warning">{{ voidedOrders.length }}</span> &nbsp; Voided Orders</a>
          </router-link>
        </ul>
      </div>
      <router-view ref="order_box"></router-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment       from "moment/moment"

export default {
  name: 'orders',
  data() {
    return {
      last_check: 'never',
      check_interval: 0
    }
  },
  mounted() {
    this.getLastRefresh()
    this.check_interval = setInterval(this.getLastRefresh, 1000)
  },
  beforeDestroy() {
    clearInterval(this.check_interval)
  },
  computed: Object.assign({}, mapGetters([
    'apiBusy',
    'isSuperUser',
    'ordersLastSync',
    'orders',
    'allOrders',
    'newOrders',
    'printedOrders',
    'archivedOrders',
    'pastOrders',
    'voidedOrders',
    'company'
  ]), {
    currentOrder() {
      return this.allOrders.find(order => order.id === parseInt(this.$route.params.id)) ||
             this.pastOrders.find(order => order.id === parseInt(this.$route.params.id))
    }
  }),
  methods: {
    getLastRefresh() {
      this.last_check = moment(this.ordersLastSync).fromNow()
    },
    refreshAll() {
      if (this.orders.length > 500) {
        let confirm = window.confirm("Are you sure? This may take a minute.")
        if (confirm) {
          this.$store.dispatch('REFRESH_ORDERS')
        }
      }
      else {
        this.$store.dispatch('REFRESH_ORDERS')
      }
    },
    printAll() {
      let contents = [];
      switch (this.$route.name) {
        case 'orders':
          contents = this.newOrders
          break
        case 'printed-orders':
          contents = this.printedOrders
          break
        case 'archived-orders':
          contents = this.archivedOrders
          break
        case 'voided-orders':
          contents = this.voidedOrders
          break
      }
      this.$bus.$emit('startPrint', {
        type: 'order',
        contents,
      })
    },
    printOrder() {
      this.$bus.$emit('startPrint', {
        type: 'order',
        contents: [this.orders.find(order => order.id === parseInt(this.$route.params.id))]
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// Orders.vue?7e9cb537